import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import aboutimg from '../assets/img/guy-shows-document-girl-group-young-freelancers-office-have-conversation-working.jpg';
import CountUp from 'react-countup'

const About = () => {

  return (
        <section className="about" id="about">
            <Container>
                <h1 className='servhdng prod-hdng about-hdng'>About Us</h1>
                <p className='servheadpara prod-para'>Autoverse has been serving its clients from year 2009. Since the inception,
                    we always wanted to give the best of services to our clients and adhering to this philosophy, 
                    we have served so many companies and helped so that these organizations can do wonders in the 
                    industry.
                </p>

                <Row className="align-items-center mt-xl-5 about-text">
                    <Col xs={{span:12,order:2}} md={{span:6,order:1}} xl={{span:7,order:1}} >  
                        <h1>WHO WE ARE</h1>
                        <p>
                            We are a prominent web and mobile app development company and work in tandem with clients 
                            offering them the best quality with market relevancy using latest technologies and ongoing trends 
                            which let our clients boost their business standing strong in the competitive market.
                        </p>
                        <h1 className='age-about'> In Last 12 Years</h1>
                        <Row className='counter-itemdiv'>
                            <Col xs={12} md={4} xl={4}>
                                <p><span><CountUp end={1114} duration={3}/>+</span><br></br>Project Completed</p>
                            </Col>
                            <Col xs={12} md={4} xl={4}>
                                <p><span><CountUp end={236} duration={3}/>+</span><br></br>Clients Served</p>
                            </Col>
                            <Col xs={12} md={4} xl={4}>
                                <p><span><CountUp end={120} duration={3}/>+</span><br></br>PROFESSIONALS</p>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={{span:12,order:1}} md={{span:6,order:2}} xl={{span:5,order:2}} className="aboutimg">
                        <img src={aboutimg} alt="Header Img"  />
                    </Col>
                </Row>
            </Container>
        </section>
  )
}

export default About
